import { getBookingSuccessType } from '../../../APIDocs/apiTypes';
import { SiteAddressCard } from './jobDetails/SiteAddressCard';
import { useDefinedParams } from '../hooks/useDefinedParams';
import { SiteContactCard } from './jobDetails/SiteContactCard';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { BookingDetailsCard } from './jobDetails/BookingDetailsCard';
import { FieldDetailsCard } from './jobDetails/FieldDetailsCard';
import { UpdateDetailsCard } from './jobDetails/UpdateDetailsCard';
import { CancellationDetailsCard } from './jobDetails/CancellationDetailsCard';
import { KeyJobDetailsCard } from './jobDetails/KeyJobDetailsCard';
import { CancelJobButton } from './CancelJobButton';
import { useUserInfo } from '../hooks/useUserInfo';
import { FormEditJob } from './booking/editJob/FormEditJob';
import { RebookJobNew } from './booking/rebooking/RebookJobNew';

export const Job = () => {
  const { canAccess } = useUserInfo();
  const [bookingId, mpan, serviceLine, contractId] = useDefinedParams(['bookingId', 'mpan', 'serviceLine', 'contractId']);
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as {
    bookingData?: getBookingSuccessType;
    activeMopAppointment?: boolean;
  };

  const bookingData = state?.bookingData;
  const activeMopAppointment = state?.activeMopAppointment;

  if (bookingData == undefined) {
    navigate('/404');
    return <span></span>;
  }

  const isJobRebookable = bookingData.Status === 'Cancelled' && canAccess('canRebook') === true && bookingData.JobTypeCode != undefined && activeMopAppointment != false;

  return (
    <div id="jbp-job-screen" className="mx-10 mt-6">
      <div className="flex flex-row justify-end mb-4 gap-4">
        {bookingData.IsCancellable === true && canAccess('canCancelBooking') === true && <CancelJobButton bookingId={bookingId} mpan={mpan} serviceLine={serviceLine} />}
        {bookingData.IsEditable === true && canAccess('canEditBooking') === true && (
          <FormEditJob bookingId={bookingId} mpan={mpan} contractId={contractId} serviceLine={serviceLine} booking={bookingData} />
        )}
        {isJobRebookable && <RebookJobNew bookingId={bookingId} mpan={mpan} serviceLine={serviceLine} booking={bookingData} />}
      </div>
      <KeyJobDetailsCard booking={bookingData} />
      <div className="grid grid-cols-12 gap-6 mt-6 pb-10">
        <div className="col-span-6 lg:col-span-2 grid grid-cols-1 gap-6 place-content-start">
          <SiteContactCard contactDetails={bookingData.SiteContactDetails} />
          <UpdateDetailsCard booking={bookingData} />
        </div>
        <div className="col-span-6 lg:col-span-2 grid grid-cols-1 gap-6 place-content-start">
          <SiteAddressCard siteAddress={bookingData.AddressDetails} />
          <CancellationDetailsCard booking={bookingData} />
        </div>
        <div className="col-start-1 row-start-1 lg:col-start-5 col-span-full lg:col-span-8 grid grid-cols-1 gap-6 place-content-start">
          <BookingDetailsCard booking={bookingData} />
          <FieldDetailsCard booking={bookingData} />
        </div>
      </div>
    </div>
  );
};
